import { formatPrice } from './format';
import i18next from 'i18next';

export const parseBenefitToText = (benefit, currencyCode = 'ILS') => {
    const { financialType, value } = benefit.type;

    switch (financialType) {
        case 'PERCENT':
            return value + '% ' + i18next.t('discountOnEntireMenu').toLowerCase();
        case 'AMOUNT':
            return formatPrice(value, currencyCode) + ' ' + i18next.t('gift').toLowerCase();
        default:
            return value;
    }
};